import Vue from 'vue'
import './css/index.less'
import { Button, Modal, InputNumber } from 'ant-design-vue'
import Cart from '@/components/cart'
import moment from 'moment'
import ImgCaptcha from '@/components/imgcaptcha'
import '@/components/l8-icon'
Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(InputNumber)
Vue.use(Cart)
Vue.use(ImgCaptcha)
Vue.prototype.moment = moment
Vue.prototype.$modal = Modal
Vue.prototype.$error = Modal.error
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
